export default __webpack_public_path__ + "static/zaru_collages_v6-12-dc89ee2e72f6d499fb3966cf780998fa.png";